import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../config/api';
import './CmsPage.css';

const CmsPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        // setError(null);
        // console.log('Fetching page with slug:', slug);
        const pageData = await api.getPageBySlug(slug);
        // console.log('Page data received:', pageData);
        if (pageData && pageData.title) {
          setPage(pageData);
        } else {
          throw new Error('Invalid page data received');
        }
      } catch (err) {
        console.error('Error loading page:', err);
        setError(err.message || 'Failed to load page content');
        setPage(null);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPage();
    } else {
      setLoading(false);
      setError('No page slug provided');
    }
  }, [slug]);

  if (loading) {
    return (
      <>
        {/* Quick Navigation */}
        {/* <div className="quicknav">
          <div className="container">
            <ul>
              <li><a href="#">Group Booking</a></li>
              <li><a href="#">Offers & Promotion</a></li>
              <li><a href="#">FAQ</a></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>
        </div> */}
        <div className="cms-page">
          <div className="cms-loading">
            <div className="spinner"></div>
            <p>Loading content...</p>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        {/* Quick Navigation */}
        {/* <div className="quicknav">
          <div className="container">
            <ul>
              <li><a href="#">Group Booking</a></li>
              <li><a href="#">Offers & Promotion</a></li>
              <li><a href="#">FAQ</a></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>
        </div> */}
        <div className="cms-page">
          <div className="cms-error">
            <h2>Error Loading Page</h2>
            <p>{error}</p>
            <p className="cms-error-hint">Please check if the page exists in the database.</p>
          </div>
        </div>
      </>
    );
  }

  if (!page) {
    return (
      <>
        {/* Quick Navigation */}
        {/* <div className="quicknav">
          <div className="container">
            <ul>
              <li><a href="#">Group Booking</a></li>
              <li><a href="#">Offers & Promotion</a></li>
              <li><a href="#">FAQ</a></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>
        </div> */}
        <div className="cms-page">
          <div className="cms-error">
            <h2>Page Not Found</h2>
            <p>The requested page could not be found.</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Quick Navigation */}
      {/* <div className="quicknav">
        <div className="container">
          <ul>
            <li><a href="#">Group Booking</a></li>
            <li><a href="#">Offers & Promotion</a></li>
            <li><a href="#">FAQ</a></li>
            <li><a href="#">Contact Us</a></li>
          </ul>
        </div>
      </div> */}

      <div className="cms-page">
        <div className="container">
          <div className="cms-content">
            <h1>{page.title}</h1>
            {page.metaDescription && (
              <p className="cms-meta-description">{page.metaDescription}</p>
            )}
            <div 
              className="cms-body" 
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CmsPage;

